<div class="dollar-sign"><span *ngIf="negative">-</span>$</div><div class="dollars">{{dollars}}</div><div class="cents">{{cents}}</div>